import { Injectable } from '@angular/core';
import { ShotType, ShotTypeFilters } from '../models/new/shot';

@Injectable({
	providedIn: 'root'
})
export class ShotTypeMapper {
	toShotType(node: any): ShotType {
		return new ShotType({
			id: node.id,
			code: node.code,
			name: node.name,
			isInUse: !!node.isInUse,
			orderType: node.orderTypeId ?? undefined
		});
	}

	// Le mappe arrivano con la predefinita in testa: l'ordine dei codici la segue.
	toLegacyCodesByShotType(maps: any[]): Map<number, string[]> {
		const codesByShotType = new Map<number, string[]>();
		for (const exportMap of maps) {
			for (const shot of exportMap.shots || []) {
				if (!shot.active || !shot.code) {
					continue;
				}
				const codes = codesByShotType.get(shot.shotTypeId) || [];
				if (!codes.includes(shot.code)) {
					codes.push(shot.code);
				}
				codesByShotType.set(shot.shotTypeId, codes);
			}
		}
		return codesByShotType;
	}

	toWhereClause(filters: ShotTypeFilters) {
		return {
			name: filters.name ? { contains: filters.name } : undefined
		};
	}

	filtersToUrl(filters: ShotTypeFilters): any {
		return {
			name: filters.name || undefined,
			page: filters.page || 1,
			size: filters.size || 20
		};
	}

	urlToFilters(url: any): ShotTypeFilters {
		return new ShotTypeFilters({
			name: url.name || undefined,
			page: url.page ? Number(url.page) : 1,
			size: url.size ? Number(url.size) : 20
		});
	}
}
